import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { UserPasswordStrength } from './UserPasswordStrength';

export const UserPasswordStrengthBridge = react2angular(UserPasswordStrength, [
  'password'
]);
